<template>
  <v-card
    color="white"
    light
    class="mb-2 pa-2 black--text"
    :class="{ 'completada': tarea.completada }"
  >
    <div class="d-flex align-center black--text">
      <v-checkbox
        :input-value="tarea.completada"
        hide-details
        dense
        class="mt-0 mr-1 shrink checkbox-tarea"
        color="primary"
        @change="$emit('toggle-completada', tarea)"
      />
      <div class="flex-grow-1 min-width-0">
        <span
          class="text-body-2 d-block"
          :class="{ 'text-decoration-line-through grey--text': tarea.completada }"
        >
          {{ tarea.titulo }}
        </span>
        <span
          v-if="tarea.notas"
          class="text-caption d-block mt-1"
        >
          {{ tarea.notas }}
        </span>

        <span
          v-if="tarea.nombre_completo"
          class="text-caption grey--text text--darken-3 d-block"
        >
          Autor: {{ tarea.nombre_completo }}
        </span>
        <div v-if="listaInvolucrados.length" class="mt-1">
          <span class="text-caption grey--text text--darken-3">Involucrados:</span>
          <ul class="text-caption ma-0 mt-1 pl-3 grey--text text--darken-2">
            <li v-for="(nombre, i) in listaInvolucrados" :key="i">{{ nombre }}</li>
          </ul>
        </div>
      </div>
      <v-btn icon x-small @click="$emit('editar', tarea)" color="primary">
        <v-icon small>mdi-pencil</v-icon>
      </v-btn>
      <v-btn icon x-small @click="$emit('eliminar', tarea)" color="error">
        <v-icon small>mdi-delete</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>
  
  <script>
  export default {
    name: 'EisenhowerTarea',
    props: {
      tarea: { type: Object, required: true }
    },
    computed: {
      listaInvolucrados() {
        const inv = this.tarea.involucrados
        if (!inv || (typeof inv !== 'string' && !Array.isArray(inv))) return []
        const str = Array.isArray(inv) ? inv.join(', ') : inv
        return str.split(',').map(s => s.trim()).filter(Boolean)
      }
    }
  }
  </script>
  
  <style scoped>
    .completada { opacity: 0.75; }

    /* Checkbox visible sobre fondo blanco */
    ::v-deep .checkbox-tarea .v-icon {
      color: rgba(0, 0, 0, 0.54) !important;
    }
    ::v-deep .checkbox-tarea.v-input--is-active .v-icon,
    ::v-deep .checkbox-tarea.v-input--is-selected .v-icon {
      color: rgb(var(--v-primary-base)) !important;
    }
  </style>